<template>
    <v-touch @swiperight="onSwipe" id="edit-result-wrapper" v-if="SelectedHeat !== '' && SelectedResultId !== '' && SelectedEntrantId !== ''"
    :swipe-options="{
             direction: 'horizontal'
         }">
         <div class="error" v-if="HeatState < 2">
             {{$t('text.notStartetError')}}
         </div>
        <horizontal-editor v-if="!isVertical"></horizontal-editor>
        <vertical-editor v-if="isVertical"></vertical-editor>
        <focus-watch v-if="ShowFocusWatch"></focus-watch>
    </v-touch>
</template>

<script>

import HorizontalEditor from './HorizontalEditor.vue';
import VerticalEditor from './VerticalEditor.vue';
import FocusWatch from './FocusWatch';
// import VTouch from 'vue-touch';

import { mapGetters, mapMutations } from 'vuex';
import navMut from '../store/mutations/navigation';

export default {
    name: "EditResult",
    data: function(){
        return {
        }
    },
    methods:{    
        ...mapMutations([
            navMut.SHOWNAVPOINT,
            navMut.HIDENAVPOINT]), 
        onSwipe(e){
            if (!this.$route.path.includes('/startlist'))
                    this.$router.push('/competition/events/event/startlist');
        },
    },
    computed:{
        ...mapGetters(['SelectedHeat', 'HeatState', 'SelectedEntrantId', 'SelectedResultId', 'ShowFocusWatch']),
        isVertical(){
            return [2, 3].includes(parseInt(this.SelectedHeat.type));
        },
    },
    components: {
        HorizontalEditor,
        VerticalEditor,
        FocusWatch,
    },
    mounted() {        
        this.SHOWNAVPOINT([2]);
        if (!this.$route.path.includes('/startlist'))
            this.SHOWNAVPOINT([1]);
    },
    beforeDestroy(){        
        this.HIDENAVPOINT([1, 2]);
    }
}
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";

    #edit-result-wrapper {
        @extend %f-column;
        @extend %f-grow;

        min-width: 310px;
        max-width: 100%;
        overflow: hidden;

        .error {
            height:50px;
            font-size:25px;
            background-color:$prim_aleart_light_color;
            line-height: 50px;
            text-align: center;
        }
    }

</style>